import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/components/base/base.component';
import { PaymentTracker } from '../../core/models/paymentTracker';
import { PaymentTrackerService } from '../../core/services/PaymentTracker.service';
import { BaseService } from 'src/app/core/services/base.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { TeacherService } from 'src/app/core/services/teacher.service';
import { Teacher } from '../../core/models/teacher';
import { Enrollment } from 'src/app/core/models/enrollment';
import { DatePipe } from '@angular/common';
import { EnrollmentService } from 'src/app/core/services/enrollment.service';

@Component({
  selector: 'app-teacher-payments',
  templateUrl: './teacher-payments.component.html',
  styleUrls: ['./teacher-payments.component.scss']
})
export class TeacherPaymentsComponent extends BaseComponent implements OnInit {

  userFullName: string;
  teacherId: number;
  tokenValid: boolean;

  isTeacher: string;
  paymentTrackers: PaymentTracker[];
  teacher = {} as Teacher;

  confirmPaymentObj = {} as PaymentTracker;

  enrollment = {} as Enrollment;
  academyToken: string;

  constructor(
    public baseService: BaseService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private paymentTrackerService: PaymentTrackerService,
    private teacherService: TeacherService,
    public datepipe: DatePipe,
    private enrollmentService: EnrollmentService
  ) { super() }

  ngOnInit(): void {
    this.userFullName = localStorage.getItem('userFullName');
    this.academyToken = localStorage.getItem('academyToken');
    var teachId = localStorage.getItem('teacherId');
    this.teacherId = Number(teachId);

    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    this.isTeacher = isTeacher
    if (token && isTeacher) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.teacherService.get(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.teacher = data.result.returnData;
        // console.log(this.teacher)
      }
    )

    this.paymentTrackerService.getPaymentTrackerById(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.paymentTrackers = data.result.returnData;
        // console.log(data.result.returnData)
      }
    )
  }

  viewProfile(id) {
    this.router.navigate(['/teacher-profile/edit', this.teacherId]);
  }

  viewCourses(id) {
    this.router.navigate(['/teacher-courses/edit', this.teacherId]);
  }

  viewSettings(id) {
    this.router.navigate(['/teacher-settings/edit', this.teacherId]);
  }

  ViewPayments(id) {
    this.router.navigate(['/teacher-payments/edit', this.teacherId]);
  }

  confirmPayment(teacherId: number, studentId: number, courseId: number) {
    debugger
    this.confirmPaymentObj.teacherId = teacherId;
    this.confirmPaymentObj.studentId = studentId;
    this.confirmPaymentObj.courseId = courseId;

    this.paymentTrackerService.confirmPayment(this.confirmPaymentObj).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        // console.log(data);
        if (data.result.message.type === 'Success') {
          this.alertService.success(this.translate.instant('paymentConfirmed'))
          this.paymentTrackerService.getPaymentTrackerById(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (data: any) => {
              this.paymentTrackers = data.result.returnData;

              this.enrollment.academyToken = this.academyToken;
              this.enrollment.studentId = studentId;
              this.enrollment.favorite = true;
              this.enrollment.enrolled = true;
              this.enrollment.courseId = courseId;
              this.enrollment.enrollmentDate = this.datepipe.transform(new Date());

              this.enrollmentService.enrollment(this.enrollment).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
                (data: any) => {
                  if (data.result.message.type === 'Success') {
                  }
                  else if (data.result.message.content === 'This Course is not Available right now') {
                    this.alertService.error(this.translate.instant('thisCourseisNotAvailable'));
                  }
                }
              )
            }
          )
        }
        else {
          this.alertService.error('errorPayment')
        }
      }
    )
  }

}
